var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5143_9311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 6.02734C7.43225 6.02734 5.75 7.70959 5.75 9.77734C5.75 11.8451 7.43225 13.5273 9.5 13.5273C11.5677 13.5273 13.25 11.8451 13.25 9.77734C13.25 7.70959 11.5677 6.02734 9.5 6.02734ZM9.5 12.7773C7.8455 12.7773 6.5 11.4318 6.5 9.77734C6.5 8.12284 7.8455 6.77734 9.5 6.77734C11.1545 6.77734 12.5 8.12284 12.5 9.77734C12.5 11.4318 11.1545 12.7773 9.5 12.7773ZM18.125 9.40234H16.9902C16.8005 5.56459 13.7127 2.47684 9.875 2.28709V1.15234C9.875 0.945344 9.707 0.777344 9.5 0.777344C9.293 0.777344 9.125 0.945344 9.125 1.15234V2.28709C5.28725 2.47684 2.1995 5.56459 2.00975 9.40234H0.875C0.668 9.40234 0.5 9.57034 0.5 9.77734C0.5 9.98434 0.668 10.1523 0.875 10.1523H2.00975C2.1995 13.9901 5.28725 17.0778 9.125 17.2676V18.4023C9.125 18.6093 9.293 18.7773 9.5 18.7773C9.707 18.7773 9.875 18.6093 9.875 18.4023V17.2676C13.7127 17.0778 16.8005 13.9893 16.9902 10.1523H18.125C18.332 10.1523 18.5 9.98434 18.5 9.77734C18.5 9.57034 18.332 9.40234 18.125 9.40234ZM9.5 16.5273C5.7785 16.5273 2.75 13.4996 2.75 9.77734C2.75 6.05509 5.7785 3.02734 9.5 3.02734C13.2215 3.02734 16.25 6.05509 16.25 9.77734C16.25 13.4996 13.2215 16.5273 9.5 16.5273Z",
    fill: "#3980FF",
    stroke: "#3980FF",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5143_9311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.777344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPicker);
export default __webpack_public_path__ + "static/media/location-picker.f5b8ab0cf50692a99d04ddcaf42814a1.svg";
export { ForwardRef as ReactComponent };